import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { Box, List } from 'components/ui';
import { WhiteCard } from 'components/styles_components/card';
import { CardTitleTypography } from 'components/styles_components/typography';
import { StyledLink } from 'components/styles_components/link';
import { useError } from 'contexts/error';
import { InspectionSubjectsLink } from 'utils/link';
import InspectionSubjectsQuery from 'queries/inspection_subject/index';
import ListItem from 'components/inspection_subject/index/list_item';
import ListHeader from 'components/inspection_subject/index/list_header';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';

const InspectionSubjectAttention = () => {
  const setError = useError();
  const {
    data = { inspectionSubjects: { inspectionSubjects: [], inspectionSubjectsTotalPages: 1 } },
    loading,
    error,
  } = useQuery(InspectionSubjectsQuery, {
    variables: {
      bucket: 'overdue',
      page: 1,
    },
    fetchPolicy: 'cache-and-network',
    onError: () => {
      setError('error.inspection_subject.index');
    },
  });

  const inspectionSubjects = data.inspectionSubjects.inspectionSubjects;
  const hasMore = data.inspectionSubjects.inspectionSubjectsTotalPages > 1;

  return (
    <WhiteCard>
      <LoaderContainer loading={loading} error={error} wrap={false}>
        <CardTitleTypography variant="h5">
          <FormattedMessage id="dashboard.inspection_subjects_attention.title" />
        </CardTitleTypography>
        {inspectionSubjects.length === 0 ? (
          <InfoContainer visible>
            <FormattedMessage id="dashboard.inspection_subjects_attention.empty" />
          </InfoContainer>
        ) : (
          <>
            <List>
              <ListHeader />
              {inspectionSubjects.map((inspectionSubject) => (
                <ListItem key={inspectionSubject.id} inspectionSubject={inspectionSubject} />
              ))}
            </List>
            {hasMore && (
              <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                <StyledLink to={InspectionSubjectsLink()}>
                  <FormattedMessage id="dashboard.inspection_subjects_attention.show_more" />
                </StyledLink>
              </Box>
            )}
          </>
        )}
      </LoaderContainer>
    </WhiteCard>
  );
};

export default InspectionSubjectAttention;
